export default "__VITE_ASSET__CFP8x8Am__"